export default {
      id: "team-focus-usage",
      viewBox: "0 0 64.782 64.686",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#team-focus",
      toString: function () {
        return this.url;
      }
    }